import { render, staticRenderFns } from "./StepVerdictBar.vue?vue&type=template&id=228a20fc&scoped=true"
import script from "./StepVerdictBar.vue?vue&type=script&setup=true&lang=js"
export * from "./StepVerdictBar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./StepVerdictBar.vue?vue&type=style&index=0&id=228a20fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228a20fc",
  null
  
)

export default component.exports